var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialsPortal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Attachment_-_Flaticon-2_1_",
    "data-name": "Search results for Attachment - Flaticon-2 (1)",
    transform: "translate(-15.394 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16242",
    "data-name": "Group 16242",
    transform: "translate(15.394 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16241",
    "data-name": "Group 16241",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M42.028,9.2a1.3,1.3,0,0,0-1.756,0L25.35,23.3a5.194,5.194,0,0,1-7.02,0,4.472,4.472,0,0,1,0-6.6L33.695,2.183a3.246,3.246,0,0,1,4.386,0,2.794,2.794,0,0,1,0,4.125L25.353,18.272l0,0a1.3,1.3,0,0,1-1.752,0,1.117,1.117,0,0,1,0-1.649l6.143-5.775a1.118,1.118,0,0,0,0-1.65,1.3,1.3,0,0,0-1.756,0l-6.143,5.775a3.353,3.353,0,0,0,0,4.949,3.894,3.894,0,0,0,5.266,0l0,0L39.836,7.96a5.03,5.03,0,0,0,0-7.425,5.843,5.843,0,0,0-7.9,0L16.573,15.051a6.707,6.707,0,0,0,0,9.9,7.791,7.791,0,0,0,10.533,0l14.925-14.1A1.118,1.118,0,0,0,42.028,9.2Z",
    transform: "translate(-14.394 1.002)",
    fill: "#121212"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsPortal);
export default __webpack_public_path__ + "static/media/materialsPortal.af274ecd7259b5bf2ae721c790d7e7a3.svg";
export { ForwardRef as ReactComponent };